import { faLocationCrosshairs } from "@fortawesome/pro-regular-svg-icons"
import { CoreButton } from "component/w24/component/CoreButton"
import { CoreButton2 } from "component/w24/component/CoreButton2"
import { LinkItem } from "component/w24/component/LinkItem"
import { PhonesDemo } from "component/w24/component/PhonesDemo"
import { T1 } from "component/w24/component/T1"
import { W1 } from "component/w24/component/W1"
import { ChoiceMenu } from "component/w24/structure/ChoiceMenu"
import { Localization } from "libs/localization/localization"
import { EVariables } from "libs/style/w24_styling"
import { useIsWide } from "libs/utils/logic/responsiveLogic"
import React, { useState } from "react"
import { Link as Link2 } from "react-scroll"
import styled from "styled-components/macro"

interface Props {
  className?: string
  id?: string
}

export const LandingHeader = (props: Props): JSX.Element => {
  const [selectedIndex, setSelectedIndex] = useState(0)
  const isWide = useIsWide()

  const demos: {
    title: string
    url: string
    image1: string
    image2: string
  }[] = [
    {
      title: Localization.DEMO1,
      url: "https://app.mapheim.com/event/koiene",
      image1: "/phones1a.png",
      image2: "/phones1b.png",
    },
    {
      title: Localization.DEMO2,
      url: "https://app.mapheim.com/event/namsskogan",
      image1: "/phones2a.png",
      image2: "/phones2b.png",
    },
    {
      title: Localization.DEMO3,
      url: "https://app.mapheim.com/event/bm",
      image1: "/phones3a.png",
      image2: "/phones3b.png",
    },
    {
      title: Localization.DEMO4,
      url: "https://app.mapheim.com/event/50ed42a5-bb7d-46ef-a7bb-d63cefd342fa",
      image1: "/phones4a.png",
      image2: "/phones4b.png",
    },
  ]

  return (
    <S_LandingHeader className={props.className} id={props.id}>
      {isWide && (
        <W1>
          {Localization.TITLE1}
          <br /> {Localization.TITLE2}
        </W1>
      )}
      {!isWide && (
        <W1>
          {Localization.TITLE1} {Localization.TITLE2}
        </W1>
      )}
      <S_T1>
        {Localization.DESC1} “<b>{Localization.DESC1_1}</b>,{" "}
        <b>{Localization.DESC1_2}</b> {Localization.AND}{" "}
        <b>{Localization.DESC1_3}</b>” {Localization.DESC1_4} <br />
        {Localization.DESC2}
      </S_T1>
      <S_Content>
        <S_Row>
          <S_Button1
            to="contact"
            spy={true}
            smooth={true}
            offset={-50}
            duration={500}
          >
            <S_CoreButton
              title={Localization.ACTION1}
              icon={faLocationCrosshairs}
            />
          </S_Button1>
          {isWide && (
            <S_Button2
              href="https://app.mapheim.com/admin"
              target="_blank"
              rel="noreferrer"
            >
              <S_CoreButton2 title={Localization.TRIAL_ACCESS} badge="BETA" />
            </S_Button2>
          )}
        </S_Row>
        <S_Row>
          <S_ChoiceMenu
            selectedIndex={selectedIndex}
            items={[
              Localization.DEMO1_TITLE,
              Localization.DEMO2_TITLE,
              Localization.DEMO3_TITLE,
              Localization.DEMO4_TITLE,
            ]}
            onSelected={index => {
              setSelectedIndex(index)
            }}
          />
        </S_Row>
      </S_Content>
      <S_PhonesDemo selectedIndex={selectedIndex} demos={demos} />
      <S_LinkItem
        title={demos[selectedIndex].title}
        link={demos[selectedIndex].url}
        target="_blank"
      />
    </S_LandingHeader>
  )
}

const S_LandingHeader = styled.div`
  width: 100%;
  min-height: 778px;
  border-radius: ${EVariables.Radius2};
  background-color: linear-gradient(180deg, rgba(203, 225, 244, 1) 0%, #f99a6d);
  background-image: url("/bg_mobile.jpg");
  background-size: cover;
  display: flex;
  flex-direction: column;
  padding: 38px 25px;
  position: relative;
  @media only screen and (min-width: 1260px) {
    height: 585px;
    min-height: unset;
    padding: 65px 67px;
    background-image: url("/bg.jpg");
  }
`

const S_T1 = styled(T1)`
  margin: 28px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 23px 0 0 0;
  }
`

const S_CoreButton = styled(CoreButton)``

const S_CoreButton2 = styled(CoreButton2)``

const S_Button1 = styled(Link2)`
  margin: 43px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 100px 0 0 0;
  }
`

const S_Button2 = styled.a`
  margin: 20px 0 0 0;
  @media only screen and (min-width: 1260px) {
    margin: 100px 0 0 32px;
  }
`

const S_ChoiceMenu = styled(ChoiceMenu)`
  margin: 40px 0 245px 8px;
  justify-content: flex-start;
  @media only screen and (min-width: 1260px) {
    margin: 40px 0 0 8px;
  }
`

const S_PhonesDemo = styled(PhonesDemo)`
  position: absolute;
  right: -80px;
  bottom: -125px;
  @media only screen and (min-width: 1260px) {
    right: -110px;
    bottom: -138px;
  }
`

const S_LinkItem = styled(LinkItem)`
  position: absolute;
  right: 13px;
  bottom: -125px;
  width: 200px;
  text-align: center;
  display: flex;
  justify-content: center;
  @media only screen and (min-width: 1260px) {
    right: 0px;
    bottom: unset;
    width: 400px;
    top: 34px;
  }
`

const S_Content = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 1260px) {
    flex-direction: column-reverse;
  }
`

const S_Row = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (min-width: 1260px) {
    flex-direction: row;
  }
`
